import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/img/login_icon2.png';
const _hoisted_1 = {
  class: "login-form"
};
const _hoisted_2 = {
  class: "login-box"
};
const _hoisted_3 = {
  class: "login-input"
};
const _hoisted_4 = {
  class: "captcha-container"
};
const _hoisted_5 = ["src"];
import { ElMessage } from 'element-plus';
import { useRouter } from 'vue-router';
import { encrypt, setToken, treeDataTranslate } from '@/common/utils/index';
import { useLoginStore, useLayoutStore } from '@/store';
import LoginController from '@/api/system/LoginController';

import { onMounted, ref, reactive } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    onMounted(() => {
      layoutStore.setMenuList([]);
      loginStore.setUserInfo({});
      setToken(null);
    });
    const loginForm = ref();
    const loginStore = useLoginStore();
    const layoutStore = useLayoutStore();
    const router = useRouter();
    const dataForm = reactive({
      mobilePhone: '',
      password: '',
      captcha: '',
      checkCodeKey: ''
    });
    // 验证码图片地址
    const captchaImgSrc = ref('');
    // 存储生成的验证码答案
    const captchaAnswer = ref('');
    // 前端生成验证码图片
    const generateCaptchaImg = () => {
      LoginController.captcha().then(data => {
        if (data.success) {
          // 生成随机验证码
          captchaAnswer.value = data.data.captcha || '';
          dataForm.checkCodeKey = data.data.checkCodeKey || '';
          // 绘制验证码图片
          captchaImgSrc.value = drawCaptcha(captchaAnswer.value);
        } else {
          ElMessage.error('获取验证码错误，请联系管理员');
        }
      }).catch(e => {
        console.error(e);
        ElMessage.error('获取验证码错误，请联系管理员');
      });
    };
    // 使用Canvas绘制验证码图片
    const drawCaptcha = text => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      if (!ctx) return '';
      // 设置画布尺寸
      canvas.width = 120;
      canvas.height = 50;
      // 背景色
      ctx.fillStyle = '#f5f5f5';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      // 绘制干扰线
      for (let i = 0; i < 5; i++) {
        ctx.strokeStyle = `rgb(${Math.random() * 100}, ${Math.random() * 100}, ${Math.random() * 100})`;
        ctx.beginPath();
        ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.lineWidth = Math.random() * 2;
        ctx.stroke();
      }
      // 绘制干扰点
      for (let i = 0; i < 30; i++) {
        ctx.fillStyle = `rgb(${Math.random() * 100}, ${Math.random() * 100}, ${Math.random() * 100})`;
        ctx.beginPath();
        ctx.arc(Math.random() * canvas.width, Math.random() * canvas.height, 1, 0, Math.PI * 2);
        ctx.fill();
      }
      // 绘制验证码文本
      ctx.font = 'bold 24px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      // 每个字符随机颜色和旋转角度
      for (let i = 0; i < text.length; i++) {
        ctx.fillStyle = `rgb(${Math.random() * 100 + 50}, ${Math.random() * 100 + 50}, ${Math.random() * 100 + 50})`;
        ctx.save();
        ctx.translate(25 + i * 20, canvas.height / 2);
        ctx.rotate((Math.random() - 0.5) * 0.3);
        ctx.fillText(text.charAt(i), 0, 0);
        ctx.restore();
      }
      return canvas.toDataURL('image/png');
    };
    // 初始化时加载验证码
    onMounted(() => {
      layoutStore.setMenuList([]);
      loginStore.setUserInfo({});
      setToken(null);
      generateCaptchaImg();
    });
    const dataRule = {
      mobilePhone: [{
        required: true,
        message: '帐号不能为空',
        trigger: 'blur'
      }],
      password: [{
        required: true,
        message: '密码不能为空',
        trigger: 'blur'
      }],
      captcha: [{
        required: true,
        message: '验证码不能为空',
        trigger: 'blur'
      }]
    };
    const dataFormSubmit = () => {
      loginForm.value?.validate(valid => {
        if (valid) {
          login();
        }
      });
    };
    const login = function () {
      // 前端先验证验证码
      if (dataForm.captcha.toLowerCase() !== captchaAnswer.value.toLowerCase()) {
        ElMessage.error('验证码错误，请重新输入');
        generateCaptchaImg(); // 刷新验证码
        return;
      }
      console.log('=== login 方法开始执行 ===');
      let params = {
        loginName: dataForm.mobilePhone,
        password: encrypt(dataForm.password),
        captcha: dataForm.captcha,
        checkCodeKey: dataForm.checkCodeKey || '',
        appType: 'web'
      };
      console.log('登录参数:', params);
      console.log('准备调用 LoginController.login');
      setToken(null);
      LoginController.login(params).then(data => {
        console.log('login >>>', data);
        if (data.data.menuList) {
          layoutStore.setMenuList(treeDataTranslate(data.data.menuList, 'menuId', 'parentId'));
          delete data.data.menuList;
        }
        setToken(data.data.tokenData);
        layoutStore.setCurrentMenu(null);
        layoutStore.clearAllTags();
        if (data.data.tokenData) {
          delete data.data.tokenData;
        }
        loginStore.setUserInfo(data.data);
        // 登录成功跳转页面
        router.replace({
          name: 'main'
        });
      }).catch(e => {
        console.error('=== 登录捕获错误详情 ===');
        console.error('错误对象:', e);
        console.error('错误消息:', e.message);
        console.error('错误堆栈:', e.stack);
        console.error('错误类型:', typeof e);
        console.error(e);
        // 登录失败时刷新验证码
        generateCaptchaImg();
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[8] || (_cache[8] = _createElementVNode("div", {
        class: "img-box"
      }, [_createElementVNode("img", {
        src: _imports_0,
        style: {
          "flex-shrink": "0",
          "height": "100%"
        }
      })], -1)), _createElementVNode("div", _hoisted_3, [_cache[6] || (_cache[6] = _createElementVNode("span", {
        class: "title"
      }, "九米物联", -1)), _cache[7] || (_cache[7] = _createElementVNode("span", {
        class: "desc"
      }, "欢迎登录", -1)), _createVNode(_component_el_form, {
        model: _unref(dataForm),
        rules: dataRule,
        "label-position": "top",
        ref_key: "loginForm",
        ref: loginForm,
        onKeyup: _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"])
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "mobilePhone",
            label: "",
            style: {
              "margin-top": "48px",
              "margin-bottom": "25px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(dataForm).mobilePhone,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(dataForm).mobilePhone = $event),
              style: {
                "width": "100%",
                "height": "50px"
              },
              placeholder: "请输入帐号"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "password",
            label: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(dataForm).password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(dataForm).password = $event),
              style: {
                "width": "100%",
                "height": "50px"
              },
              type: "password",
              placeholder: "请输入密码",
              "show-password": ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "captcha",
            label: ""
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input, {
              modelValue: _unref(dataForm).captcha,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(dataForm).captcha = $event),
              style: {
                "flex": "1",
                "height": "50px"
              },
              placeholder: "请输入验证码",
              onKeyup: _cache[3] || (_cache[3] = _withKeys($event => dataFormSubmit(), ["enter"]))
            }, null, 8, ["modelValue"]), _createElementVNode("img", {
              src: _unref(captchaImgSrc),
              alt: "验证码",
              class: "captcha-img",
              onClick: generateCaptchaImg,
              title: "点击刷新验证码"
            }, null, 8, _hoisted_5)])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_button, {
          class: "login-btn-submit",
          type: "primary",
          size: "large",
          onClick: _cache[4] || (_cache[4] = $event => dataFormSubmit()),
          style: {
            "width": "100%",
            "height": "50px",
            "margin-top": "32px",
            "font-size": "16px"
          }
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode(" 登录 ", -1)]))]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "onKeyup"])])])]);
    };
  }
});